import { Controller } from "@hotwired/stimulus"

/**
 * Admin Bulk Actions Controller
 *
 * Handles bulk selection and actions in admin panel tables.
 * CSP-compliant replacement for inline onclick handlers.
 *
 * Usage:
 *   <div data-controller="admin-bulk-actions">
 *     <input type="checkbox" data-action="admin-bulk-actions#toggleAll" />
 *     <button data-action="admin-bulk-actions#cancel">Cancel</button>
 *   </div>
 */
export default class extends Controller {
  static targets = ["form", "checkbox"]

  /**
   * Toggle all checkboxes on/off based on master checkbox state
   *
   * @param {Event} event - Checkbox change event
   */
  toggleAll(event) {
    const isChecked = event.target.checked
    const checkboxSelector = event.target.dataset.checkboxSelector || ".report-checkbox"

    document.querySelectorAll(checkboxSelector).forEach(checkbox => {
      checkbox.checked = isChecked
    })

    // Show/hide bulk actions form based on selection
    this.updateBulkActionsVisibility()
  }

  /**
   * Cancel bulk actions and reset all checkboxes
   *
   * @param {Event} event - Button click event
   */
  cancel(event) {
    event.preventDefault()

    const formId = event.target.dataset.formId || "bulk_actions_form"
    const checkboxSelector = event.target.dataset.checkboxSelector || ".report-checkbox"

    // Hide bulk actions form
    const form = document.getElementById(formId)
    if (form) {
      form.classList.add("hidden")
    }

    // Uncheck all checkboxes
    document.querySelectorAll(checkboxSelector).forEach(checkbox => {
      checkbox.checked = false
    })

    // Uncheck master checkbox
    const masterCheckboxId = event.target.dataset.masterCheckboxId
    if (masterCheckboxId) {
      const masterCheckbox = document.getElementById(masterCheckboxId)
      if (masterCheckbox) {
        masterCheckbox.checked = false
      }
    }
  }

  /**
   * Update bulk actions form visibility based on checkbox selection
   */
  updateBulkActionsVisibility() {
    const checkedCount = document.querySelectorAll(".report-checkbox:checked, .product-checkbox:checked, .listing-checkbox:checked").length
    const bulkForm = document.getElementById("bulk_actions_form")
    const counter = document.getElementById("selected_count")

    // Update counter
    if (counter) {
      counter.textContent = checkedCount
    }

    // Show/hide bulk actions form
    if (bulkForm) {
      if (checkedCount > 0) {
        bulkForm.classList.remove("hidden")
      } else {
        bulkForm.classList.add("hidden")
      }
    }
  }

  /**
   * Handle individual checkbox change
   *
   * @param {Event} event - Checkbox change event
   */
  checkboxChanged(event) {
    this.updateBulkActionsVisibility()
  }
}
